<template>
  <div class="canonical">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <div v-if="secondThemeData.length>0" v-for="secondTheme in secondThemeData" :key="secondTheme.id">
            <div :class="['defaultTab',tab===secondTheme.secondThemeName?'tabColor':'']" @click="changeTab(secondTheme)">
              <span>{{ secondTheme.secondThemeName }}</span>
            </div>
          </div>
          <div v-if="secondId" class="defaultTab tabColor">
            <span>{{name}}</span>
          </div>
          <div v-if="this.$route.query.id === 6" class="defaultTab tabColor">
            <span>{{secondThemeData2.secondThemeName}}</span>
          </div>
        </div>
      </div>

      <div class="canonical-body">
        <ul v-if="result.length>0">
          <li v-for="fruit in result" :key="fruit.id">
            <div class="title-box">
              <a class="round" :href="'/newsDetail?id=' + fruit.id"><span class="name pointer">{{ fruit.title }}</span></a>
              <span class="code">{{ fruit.publishTime }}</span>
            </div>
          </li>
        </ul>
        <div v-else class="no-data" style="text-align: center;padding: 40px;">
          暂无相关数据
        </div>
        <div class="pagination-box" v-if="page.total>0">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :total="page.total"
            :page-size="page.pageSize"
            @current-change="pageChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      page: {
        currPage: 1,
        pageSize: 10,
        total: 0
      },
      result: [],
      secondThemeData: [],
      tab: '',
      name: '',
      secondId: '',
      secondThemeData2: []
    }
  },
  mounted () {
    this.name = this.$route.query.name;
    this.secondId = this.$route.query.secondId;

    if (this.$route.query.id) {
      this.getSecondTheme();
    }
    if (this.secondId) {
      this.fetchList()
    }
  },
  methods: {
    pageChange (current) {
      this.page.currPage = current;
      this.fetchList();
    },
    fetchList (id) {
      // 请求列表
      const _self = this;
      let param = {};
      if (id) {
        param.secondThemeId = id;
      } else {
        param.secondThemeId = _self.secondId;
      }
      param.pageNo = _self.page.currPage;
      param.pageSize = _self.page.pageSize;
      _self.fetch('/dataapi/open/nqi/notice/list', param).then(res => {
        _self.result = res.result.records;
        _self.page.total = res.result.total;
      })
    },
    //  获取二级目录
    getSecondTheme () {
      const _self = this;
      if (_self.$route.query.id === 6) {
        _self.fetch('/dataapi/open/nqi/notice/listSecondThemeByFisrtId', {id: _self.$route.query.id}).then(res => {
          _self.secondThemeData2 = res.result[0];
          _self.fetchList(res.result[0].id);
        })
      } else {
        _self.fetch('/dataapi/open/nqi/notice/listSecondThemeByFisrtId', {id: _self.$route.query.id}).then(res => {
          _self.secondThemeData = res.result;
          _self.tab = res.result[0].secondThemeName;
          _self.fetchList(res.result[0].id);
        })
      }
    },
    changeTab (e) {
      const _self = this;
      _self.tab = e.secondThemeName;
      _self.fetchList(e.id);
    }
  }
}
</script>

<style lang="less">
.canonical {
  .pagination-box {
    margin-top: 60px;

    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }

    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;

        &.active {
          background-color: rgba(46, 92, 154, 1) !important;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}

.canonical {
  padding-bottom: 208px;

  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;

    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;

      .defaultTab {
        background-color: rgba(0, 0, 0, 0.1);
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 30px;
        margin-right: 12px;
        padding: 0 15px;
        cursor: pointer;

        span {
          font-size: 18px;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .tabColor {
        background-color: #136BAE;
        span {
          color: #fff;
        }
      }
    }
  }

  .title {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }

  .search-box {
    display: flex;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 24px;
    }

    .form-select {
      display: flex;
      margin-top: 6px;

      label {
        font-size: 16px;
        line-height: 40px;
        width: 85px;
      }

      li {
        cursor: pointer;
        float: left;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 0 10px;
        margin-right: 10px;
        line-height: 40px;
        border-radius: 4px;

        &.selected {
          background-color: #136BAE;
          color: #FFFFFF;
        }
      }
    }

    input {
      margin-right: 24px;
      margin-left: 12px;
      flex: 1;
      height: 52px;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 26px;
      box-sizing: border-box;
    }

    .search-btn {
      width: 120px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
      cursor: pointer;
    }
  }

  .canonical-body {
    padding-bottom: 32px;

    ul {
      li {
        padding: 12px 0;
        border-bottom: 1px dashed #b7c3da;;

        .title-box {
          display: flex;
          justify-content: space-between;

          .round {
            :before {
              border-radius: 0;
              margin-right: 10px;
              background-color: #d8d8d8;
              transition: all 0.25s;
              content: '';
              width: 6px;
              height: 6px;
              display: inline-block;
              margin-bottom: 2px;
            }

            &:hover {
              text-decoration: none;

              :before {
                background-color: #136BAE;
              }
            }
          }

          .name {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #333333;
            transition: all 0.25s;
          }

          .code {
            font-size: 12px;
            color: #333333;
            line-height: 17px;
          }
        }

        .content {
          margin-bottom: 24px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 28px;
        }

        .date-box {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 17px;
        }
      }
    }
  }

  .pagination-box {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/notice/index.vue